"use client";

import React, { useState } from "react";
import Card from "../genericComponents/card/Card";
import {
  Box,
  createTheme,
  Grid,
  Skeleton,
  Stack,
  ThemeProvider,
  Typography,
} from "@mui/material";
import ViewDetails from "../genericComponents/view-details/ViewDetails";
import { BasicProgram } from "../../classes/main";
import ViewDetailsRsOneContainer from "../genericComponents/view-details/ViewDetailsRsOneContainer";
import MakeYourOwnPackage from "../genericComponents/view-details/MakeYourOwnPackage";

interface HomePageCardsProps {
  basicProgramType: any;
}

const HomePageCards: React.FC<HomePageCardsProps> = ({ basicProgramType }) => {
  const [open, setOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(new BasicProgram());
  const [openRsOneDetails, setOpenRsOneDetails] = useState(false);
  const [viewDetailsRsOneSid, setViewDetailsRsOneSid] = useState<
    number | string | undefined
  >(undefined);
  const [updateCard, setUpdateCard] = useState(false);
  const [reloadViewDetailsItem, setReloadViewDetailsItem] = useState(false);
  const [openPackages, setOpenPackages] = useState(false);

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1350, // Adjust lg to 1400px
        xl: 1536,
      },
    },
  });

  const handleViewDetails = (basicProgram: BasicProgram, index: number) => {
    setOpen(true);
    setViewDetails(basicProgram);
  };
  const handleOpenViewDetailsRsOne = (
    basicProgram: BasicProgram,
    index: number
  ) => {
    setOpenRsOneDetails(true);
    setViewDetailsRsOneSid(basicProgram?.sid);
  };
  const handleOpenViewDetails = (sid: any) => {
    setOpenRsOneDetails(true);
    setViewDetailsRsOneSid(sid);
  };
  const setClose = () => {
    setOpen(false);
  };
  const handleEditPackage = (service: BasicProgram, index: number) => {
    setOpenPackages(true);
    setViewDetails(service);
  };

  const serviceKey = (prefix: string, item: any, index: number) =>
    `${prefix}-${item?.services?.cid ?? "c"}-${item?.services?.id ?? index}`;

  return (
    <>
      <div>
        <ThemeProvider theme={theme}>
          <Stack>
          <Grid
            container
            item
            xs={11}
            sm={11}
            md={11}
            lg={9.5}
            margin="auto"
            sx={{
              padding: { xs: "1.25rem 0 0.75rem", sm: "3rem 0rem 1rem" },
            }}
          >
            <Typography
              variant="h4"
              sx={{
                textAlign: "left",
                fontWeight: "bold",
                fontSize: { xs: "22px", sm: "34px" },
              }}
              className="home-page-cards-service-heading"
            >
              {basicProgramType.name}
            </Typography>
          </Grid>
          {/* mobile view  */}
          <Box sx={{ display: { sm: "block", md: "none" } }}>
            <Box
              sx={{
                display: "flex",
                overflowX: "auto",
                overflowY: "hidden",
                margin: { xs: "0.25rem", sm: "0.5rem" },
                gap: 1.5,
                flexWrap: "nowrap",
                pb: 0.5,
                WebkitOverflowScrolling: "touch",
              }}
            >
              {basicProgramType
                ? basicProgramType &&
                  basicProgramType.basicProgramList &&
                  basicProgramType.basicProgramList.map(
                    (item: any, index: number) => (
                      <Box
                        sx={{
                          minWidth: "300px",
                          width: "300px",
                          flexShrink: 0,
                        }}
                        key={serviceKey("basic-m", item, index)}
                      >
                        <Card
                          addOn={item?.services?.addOn}
                          id={item.services.id}
                          cid={item.services.cid}
                          url={
                            item?.services?.webBanner?.secureHttpPath ??
                            item?.services?.banner?.secureHttpPath ??
                            item.services.coverImage.secureHttpPath
                          }
                          heading={item.services.name}
                          subHeading={item.services.subHeading}
                          price={item.services.mrp}
                          discount={item.services.discount}
                          finalPrice={item.services.amount}
                          serviceDetails={item.services.aboutList}
                          serviceCharge={item.services.serviceCharge}
                          productCost={item.services.productCost}
                          min={item.services.min}
                          specialPrice={item?.services.specialPrice}
                          specialMessage={item?.services.specialMessage}
                          handleViewDetails={() =>
                            handleViewDetails(item, index)
                          }
                          handleOpenViewDetailsRsOne={() =>
                            handleOpenViewDetailsRsOne(item, index)
                          }
                          updateCard={updateCard}
                          setUpdateCard={() => setUpdateCard(false)}
                          reloadViewDetailsItem={() =>
                            setReloadViewDetailsItem(true)
                          }
                          productDetailsAvailable={
                            item?.services?.productDetailsAvailable
                          }
                          makeYourOwnPackage={false}
                          handleEditPackage={() =>
                            handleEditPackage(item, index)
                          }
                          recommendedServices={item?.recommendedServices}
                          setOpenBestPaired={false}
                          setRecommendedServices={[]}
                        />
                      </Box>
                    )
                  )
                : Array.from({ length: 1 }).map((_, i) => (
                    <Skeleton
                      key={i}
                      variant="rounded"
                      sx={{
                        margin: "2rem 0.5rem",
                        width: "270px",
                        height: "300px",
                      }}
                    />
                  ))}
              {basicProgramType
                ? basicProgramType &&
                  basicProgramType.programList &&
                  basicProgramType.programList?.map(
                    (item: any, index: number) => (
                      <Box
                        sx={{
                          minWidth: "300px",
                          width: "300px",
                          flexShrink: 0,
                        }}
                        key={serviceKey("program-m", item, index)}
                      >
                        <Card
                          addOn={item?.services?.addOn}
                          id={item.services.id}
                          cid={item.services.cid}
                          url={
                            item?.services?.webBanner?.secureHttpPath ??
                            item?.services?.banner?.secureHttpPath ??
                            item.services.coverImage.secureHttpPath
                          }
                          heading={item.services.name}
                          subHeading={item.services.subHeading}
                          price={item.services.mrp}
                          discount={item.services.discount}
                          finalPrice={item.services.amount}
                          serviceDetails={item.services.aboutList}
                          serviceCharge={item.services.serviceCharge}
                          productCost={item.services.productCost}
                          min={item.services.min}
                          specialPrice={item?.services.specialPrice}
                          specialMessage={item?.services.specialMessage}
                          handleViewDetails={() =>
                            handleViewDetails(item, index)
                          }
                          handleOpenViewDetailsRsOne={() =>
                            handleOpenViewDetailsRsOne(item, index)
                          }
                          updateCard={updateCard}
                          setUpdateCard={() => setUpdateCard(false)}
                          reloadViewDetailsItem={() =>
                            setReloadViewDetailsItem(true)
                          }
                          productDetailsAvailable={
                            item?.services?.productDetailsAvailable
                          }
                          makeYourOwnPackage={false}
                          handleEditPackage={() =>
                            handleEditPackage(item, index)
                          }
                          recommendedServices={item?.recommendedServices}
                          setOpenBestPaired={false}
                          setRecommendedServices={[]}
                        />
                      </Box>
                    )
                  )
                : Array.from({ length: 0 }).map((_, i) => (
                    <Skeleton
                      key={i}
                      variant="rounded"
                      sx={{
                        margin: "2rem 0.5rem",
                        width: "270px",
                        height: "300px",
                      }}
                    />
                  ))}
            </Box>
          </Box>
          {/* desktop View  */}
          <Grid
            container
            item
            xs={9.5}
            sm={9.5}
            md={11}
            lg={9.5}
            margin="auto"
            spacing={2}
            sx={{
              display: { xs: "none", sm: "none", md: "flex" },
              flexWrap: "wrap",
            }}
          >
            {basicProgramType
              ? basicProgramType &&
                basicProgramType.basicProgramList &&
                basicProgramType.basicProgramList.map(
                  (item: any, index: number) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        xl={3}
                        key={serviceKey("basic", item, index)}
                      >
                        <Card
                          addOn={item?.services?.addOn}
                          id={item.services.id}
                          cid={item.services.cid}
                          url={
                            item?.services?.webBanner?.secureHttpPath ??
                            item?.services?.banner?.secureHttpPath ??
                            item.services.coverImage.secureHttpPath
                          }
                          heading={item.services.name}
                          subHeading={item.services.subHeading}
                          price={item.services.mrp}
                          discount={item.services.discount}
                          finalPrice={item.services.amount}
                          serviceDetails={item.services.aboutList}
                          serviceCharge={item.services.serviceCharge}
                          productCost={item.services.productCost}
                          min={item.services.min}
                          specialPrice={item?.services.specialPrice}
                          specialMessage={item?.services.specialMessage}
                          handleViewDetails={() =>
                            handleViewDetails(item, index)
                          }
                          handleOpenViewDetailsRsOne={() =>
                            handleOpenViewDetailsRsOne(item, index)
                          }
                          updateCard={updateCard}
                          setUpdateCard={() => setUpdateCard(false)}
                          reloadViewDetailsItem={() =>
                            setReloadViewDetailsItem(true)
                          }
                          productDetailsAvailable={
                            item?.services?.productDetailsAvailable
                          }
                          makeYourOwnPackage={false}
                          handleEditPackage={() =>
                            handleEditPackage(item, index)
                          }
                          recommendedServices={item?.recommendedServices}
                          setOpenBestPaired={false}
                          setRecommendedServices={[]}
                        />
                      </Grid>
                  )
                )
              : Array.from({ length: 4 }).map((_, i) => (
                  <Skeleton
                    key={i}
                    variant="rounded"
                    sx={{
                      margin: "2rem 0.5rem",
                      width: "270px",
                      height: "300px",
                    }}
                  />
                ))}

            {basicProgramType
              ? basicProgramType &&
                basicProgramType.programList &&
                basicProgramType.programList?.map(
                  (item: any, index: number) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        xl={3}
                        key={serviceKey("program", item, index)}
                      >
                        <Card
                          addOn={item?.services?.addOn}
                          id={item.services.id}
                          cid={item.services.cid}
                          url={
                            item?.services?.webBanner?.secureHttpPath ??
                            item?.services?.banner?.secureHttpPath ??
                            item.services.coverImage.secureHttpPath
                          }
                          heading={item.services.name}
                          subHeading={item.services.subHeading}
                          price={item.services.mrp}
                          discount={item.services.discount}
                          finalPrice={item.services.amount}
                          serviceDetails={item.services.aboutList}
                          serviceCharge={item.services.serviceCharge}
                          productCost={item.services.productCost}
                          min={item.services.min}
                          specialPrice={item?.services.specialPrice}
                          specialMessage={item?.services.specialMessage}
                          handleViewDetails={() =>
                            handleViewDetails(item, index)
                          }
                          handleOpenViewDetailsRsOne={() =>
                            handleOpenViewDetailsRsOne(item, index)
                          }
                          updateCard={updateCard}
                          setUpdateCard={() => setUpdateCard(false)}
                          reloadViewDetailsItem={() =>
                            setReloadViewDetailsItem(true)
                          }
                          productDetailsAvailable={
                            item?.services?.productDetailsAvailable
                          }
                          makeYourOwnPackage={false}
                          handleEditPackage={() =>
                            handleEditPackage(item, index)
                          }
                          recommendedServices={item?.recommendedServices}
                          setOpenBestPaired={false}
                          setRecommendedServices={[]}
                        />
                      </Grid>
                  )
                )
              : Array.from({ length: 1 }).map((_, i) => (
                  <Skeleton
                    key={i}
                    variant="rounded"
                    sx={{
                      margin: "2rem 0.5rem",
                      width: "270px",
                      height: "300px",
                    }}
                  />
                ))}
          </Grid>
          </Stack>
        </ThemeProvider>
      </div>
      <ViewDetails
        open={open}
        setClose={setClose}
        sid={viewDetails?.sid}
        addOn={viewDetails?.services?.addOn}
        id={viewDetails?.services?.id}
        cid={viewDetails?.services?.cid}
        imageUrl={
          viewDetails?.services?.banner?.secureHttpPath ??
          viewDetails?.services?.coverImage?.secureHttpPath
        }
        heading={viewDetails?.services?.name}
        servicedDetails={viewDetails?.services?.aboutList}
        descriptions={viewDetails.services?.descriptions}
        amount={viewDetails.services?.amount}
        min={viewDetails?.services?.min}
        subHeading={viewDetails?.services?.subHeading}
        mrp={viewDetails?.services?.mrp}
        specialPrice={viewDetails?.services?.specialPrice}
        specialMessage={viewDetails?.services?.specialMessage}
        coin={viewDetails?.services?.cashbackSalontymCoins}
        aboutList={viewDetails?.services?.aboutList}
        serviceCharge={viewDetails?.services?.serviceCharge}
        productCost={viewDetails?.services?.productCost}
        handleOpenViewDetailsRsOne={(sid: any) => handleOpenViewDetails(sid)}
        reloadCartItemsFlag={() => setUpdateCard(true)}
        reloadViewDetailsItem={reloadViewDetailsItem}
        setReloadViewDetailsItem={() => setReloadViewDetailsItem(false)}
      />
      <ViewDetailsRsOneContainer
        open={openRsOneDetails}
        handleCloseStoreDialog={() => setOpenRsOneDetails(false)}
        viewDetailsRsOneSid={viewDetailsRsOneSid}
      />
      <MakeYourOwnPackage
        open={openPackages}
        close={() => setOpenPackages(false)}
        sid={viewDetails?.id}
      />
    </>
  );
};
export default HomePageCards;
